import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin } from 'lucide-react';
import { useLanguage } from '../i18n/LanguageContext';
import { PhoneLink, EmailLink } from './ProtectedContact';
import { PARTNER_LINKS } from '../pages/Home';

export default function Footer() {
  const { t } = useLanguage();

  const links = [
    { to: '/', label: t.nav.home, id: 'home' },
    { to: '/servizi', label: t.nav.servizi, id: 'servizi' },
    { to: '/team-building', label: t.nav.tb, id: 'team-building' },
    { to: '/location', label: t.nav.location, id: 'location' },
    { to: '/gallery', label: t.nav.gallery, id: 'gallery' },
    { to: '/chi-siamo', label: t.nav.about, id: 'chi-siamo' },
    { to: '/contatti', label: t.nav.contatti, id: 'contatti' },
  ];

  return (
    <footer className="bg-emerald-deep text-ivory grain relative" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 md:px-10 pt-20 pb-10">
        <p className="font-serif italic text-3xl md:text-4xl text-ivory/90 max-w-xl leading-snug">
          “{t.footer.tagline}”
        </p>
        <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-12">
          <div>
            <h3 className="text-xs uppercase tracking-[0.3em] text-terracotta mb-6">{t.footer.contactTitle}</h3>
            <ul className="space-y-4 text-sm text-ivory/80">
              <li>
                <PhoneLink testid="footer-phone-link" className="flex items-center gap-3 hover:text-terracotta transition-colors duration-300" icon={<Phone size={15} />} />
              </li>
              <li>
                <EmailLink testid="footer-email-link" className="flex items-center gap-3 hover:text-terracotta transition-colors duration-300" icon={<Mail size={15} />} />
              </li>
              <li className="flex items-start gap-3">
                <MapPin size={15} className="mt-0.5 shrink-0" />
                <span>Via Gustavo Modena 28, 20129 Milano</span>
              </li>
            </ul>
          </div>
          <div>
            <h3 className="text-xs uppercase tracking-[0.3em] text-terracotta mb-6">{t.footer.exploreTitle}</h3>
            <ul className="space-y-3 text-sm text-ivory/80">
              {links.map((l) => (
                <li key={l.to}>
                  <Link to={l.to} data-testid={`footer-link-${l.id}`} className="hover:text-terracotta transition-colors duration-300">
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <h3 className="text-xs uppercase tracking-[0.3em] text-terracotta mb-6">{t.footer.partnersTitle}</h3>
            <ul className="space-y-3 text-sm text-ivory/70">
              {t.home.partners.map((p) => (
                <li key={p}>
                  {PARTNER_LINKS[p] ? (
                    <a
                      href={PARTNER_LINKS[p]}
                      target="_blank"
                      rel="noopener noreferrer"
                      data-testid={`footer-partner-${p.toLowerCase().replace(/[^a-z0-9]+/g, '-')}`}
                      className="hover:text-terracotta transition-colors duration-300"
                    >
                      {p}
                    </a>
                  ) : (
                    p
                  )}
                </li>
              ))}
            </ul>
          </div>
        </div>
        <div className="mt-16 pt-8 border-t border-ivory/10 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <img src="/images/logo-ivory-transparent.png" alt="Gustavo 28" className="h-9 w-auto" data-testid="footer-logo" />
          <span className="text-xs text-ivory/50 tracking-wide" data-testid="footer-rights">{t.footer.rights}</span>
        </div>
      </div>
    </footer>
  );
}
